import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  type InputSignal,
  output,
  type OutputEmitterRef
} from '@angular/core';
import App from '@app/app';
import { downgradeComponent } from '@angular/upgrade/static';
import { NgClass } from '@angular/common';
import { Severity, SEVERITY_ICON_MAP } from '../severity/severity.config';
import { AlertVariant } from './alert.config';
import { LtIconComponent } from '../lt-icon/lt-icon.component';
import { type IconName } from '../lt-icon/lt-icon.config';

@Component({
  selector: 'lt-alert',
  standalone: true,
  imports: [NgClass, LtIconComponent],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertComponent {
  public severity: InputSignal<Severity> = input<Severity>(Severity.WARNING);
  public icon: InputSignal<IconName | undefined> = input();
  public closeable: InputSignal<boolean> = input(false);
  public title: InputSignal<string> = input('Title');
  public message: InputSignal<string> = input('');
  public items: InputSignal<string[]> = input<string[]>([]);
  public submit: InputSignal<boolean> = input(false);
  public submitType: InputSignal<string> = input('link');
  public submitButtonStyle: InputSignal<string> = input('default');
  public submitButtonIcon: InputSignal<IconName | ''> = input<IconName | ''>('');
  public submitLabel: InputSignal<string> = input('Submit');
  public variant: InputSignal<AlertVariant> = input<AlertVariant>(AlertVariant.DEFAULT);

  public close: OutputEmitterRef<void> = output<void>();
  public submitClick: OutputEmitterRef<void> = output<void>();

  public resolvedIcon = computed(() => {
    const icon = this.icon();

    return icon ?? SEVERITY_ICON_MAP[this.severity()];
  });

  public resolvedSubmitButtonIcon = computed<IconName | null>(() => {
    const icon = this.submitButtonIcon();
    return icon === '' ? null : icon;
  });

  public onCloseClick(): void {
    this.close.emit();
  }

  public onSubmitClick(): void {
    this.submitClick.emit();
  }
}

App.directive(
  'ltAlert',
  downgradeComponent({
    component: AlertComponent
  })
);
